import { DocumentNode } from 'apollo-link';
import gql from 'graphql-tag';
import { FlowsDisplayGridRowDataFragmentGql } from './FlowsDisplayGridRowDataFragmentGql';

export const FlowUpstreamFlowsFilteredByFlowOutputFieldQueryGql: DocumentNode = gql`
query FlowUpstreamFlowsFilteredByFlowOutputFieldQuery(
  $flowVizportalUrlId: String!,
  $selectedFlowOutputFieldId: ID!,
  $first: Int!,
  $offset: Int!,
  $orderBy: FlowSortOrder!
) {
  flows(filter: { vizportalUrlId: $flowVizportalUrlId }) {
    outputFieldsConnection(filter: { id: $selectedFlowOutputFieldId }) {
      nodes {
        upstreamFlowsConnection(first: $first, offset: $offset, orderBy: $orderBy) {
          totalCount
          nodes {
            ...FlowsDisplayGridRowDataFragment
          }
        }
      }
    }
  }
}
${FlowsDisplayGridRowDataFragmentGql}
`;
